import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { APP_CONFIG } from './../../../configs/app-config.constants';
import { InterfaceAppConfig } from '../../../configs/app-interface.config';

@Injectable({
    providedIn: 'root',
})
export class ArticleService {
    url: any;
    domainUrl = environment.apiurl;
    gyanDomainUrl = environment.gyanApiUrl;

    private callTopicHierarchySubject = new Subject<any>();
    callTopicHierarchyEvent$ = this.callTopicHierarchySubject.asObservable();

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {}

    getArticleList(reqBody: any): Observable<HttpResponse<any>> {
        const url = this.domainUrl + this.config.apis.articles.getArticleList;
        return this.http.post<any>(url, reqBody, { observe: 'response' });
    }

    getArticleLongStory(personId: number, articleId: number): Observable<HttpResponse<any>> {
        const url = this.domainUrl + this.config.apis.articles.getArticleLongStory + '?personId=' + personId + '&articleId=' + articleId;
        return this.http.get(url, { observe: 'response' });
    }

    getArticleNetworkDataByArticleId(personId: number, articleId: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.articles.getNetwrokGraph + '?personId=' + personId + '&articleId=' + articleId;
        return this.http.get(url);
    }

    getArticleNetworkDataByNodeId(personId: number, nodeId: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.articles.getNetwrokGraph + '?personId=' + personId + '&nodeId=' + nodeId;
        return this.http.get(url);
    }

    // for Advance Queries
    getArticleListForAdvanceQuery(reqBody: any): Observable<HttpResponse<any>> {
        const url = this.gyanDomainUrl + this.config.apis.gyan.articles.getArticleList;
        return this.http.post<any>(url, reqBody, { observe: 'response' });
    }

    getArticleLongStoryForAdvanceQuery(reqBody: any): Observable<HttpResponse<any>> {
        const url = this.gyanDomainUrl + this.config.apis.gyan.articles.getArticleLongStory;
        return this.http.post<any>(url, reqBody, { observe: 'response' });
    }

    getArticleNetworkDataByArticleIdForAdvancedQuery(payload: any): Observable<any> {
        const url =
            this.gyanDomainUrl +
            this.config.apis.gyan.articles.getNetwrokGraph +
            '?topicId=' +
            payload.topicId +
            '&isHeadNode=' +
            payload.isHeadNode +
            '&type=' +
            payload.type +
            '&limit=' +
            payload.limit +
            '&offset=' +
            payload.offset +
            '&articleId=' +
            payload.articleId;
        return this.http.get(url);
    }

    getTopicHierarchy(gyanVersion: string, topicId: number): Observable<any> {
        const url = this.gyanDomainUrl + this.config.apis.gyan.topicHierarchy + '?gyanversion=' + gyanVersion + '&topicId=' + topicId;
        return this.http.get(url);
    }

    getbooknodesummary(reqBody: any) {
        const url = this.gyanDomainUrl + this.config.apis.gyan.articleGyan.bookNodeSummary;
        return this.http.post(url, reqBody);
    }

    getTopicLevelConfig(reqBody: any): Observable<any> {
        const url = this.gyanDomainUrl + this.config.apis.gyan.articleGyan.topiclevelconfig;
        return this.http.post(url, reqBody);
    }

    getTopicLevelMultidocSummary(topicId: number) {
        const url = this.gyanDomainUrl + this.config.apis.gyan.articleGyan.topiclevelmultidocsummary + '?topicId=' + topicId;
        return this.http.get(url);
    }

    getTopicLevelGPT3Summary(topicId: number) {
        const url = this.gyanDomainUrl + this.config.apis.gyan.articleGyan.topiclevelgpt3summary + '?topicId=' + topicId;
        return this.http.get(url);
    }

    getUserDocuments(topicid: string | number): Observable<any> {
        const url = this.gyanDomainUrl + this.config.apis.gyan.articleGyan.getUserDocImages + '?topicId=' + topicid;
        return this.http.get(url);
    }

    getImageFromUrl(imgURL: string): Observable<Blob> {
        const url = this.gyanDomainUrl + this.config.apis.gyan.articleGyan.getImageFromUrl + '?url=' + imgURL;
        return this.http.get(url, { responseType: 'blob' });
    }

    emitCallTopicHierarchyEvent(topicOutline: any) {
        console.log('emitcallTopicHierarchyEvent');
        this.callTopicHierarchySubject.next(topicOutline);
    }
}
